import { UI } from '@/Components/UI';
import { ProfileRequest, User } from '@/types';
import { SubmitEventHandler } from 'react';
import { useLocalizedRoute } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { useForm, usePage } from '@inertiajs/react';

type ProfileFormProps = {
    user: User;
}

export const ProfileForm = ({ user }: ProfileFormProps) => {
    const { t } = useTranslation(['profile']);
    const { localizedRoute } = useLocalizedRoute();

    const status = usePage().props.status === 'profile-updated';
    const form = useForm<ProfileRequest>(user);

    const submit: SubmitEventHandler = (e) => {
        e.preventDefault();

        form.put(localizedRoute('account.updateProfile'));
    };

    return (
        <UI.Form<ProfileRequest> form={form} onSubmit={submit}>
            {status && (
                <div
                    className="mb-4 p-4 rounded-lg bg-secondary-container text-center text-sm font-medium text-on-secondary-container">
                    {t('profile:account.profile.updatedSuccessfully')}
                </div>
            )}

            <UI.Form.Input
                name={'name'}
                label={t('account.profile.name')}
                required
                autoComplete={'name'} />

            <UI.Form.ImageInput
                name={'profileImage'}
                label={t('account.profile.profileImage')} />

            <div className={'text-end'}>
                <UI.Button
                    type={'submit'}
                    className={'mt-4'}
                    disabled={form.processing}>
                    {t('misc:save')}
                </UI.Button>
            </div>
        </UI.Form>
    );
};
